import React, { FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';

type Props = {
  flash: boolean;
  flashType: string;
  flashMessage: string;
  handleFlash: (flash: boolean, flashType: string, flashMessage: string) => void;
};

export const Component: FunctionComponent<Props> = ({
  flash,
  flashType,
  flashMessage,
  handleFlash,
}) => {
  // ★ 5秒後に自動で非表示にする
  useEffect(() => {
    if (flash) {
      const timer = setTimeout(() => {
        handleFlash(false, '', '');
      }, 10000);

      // クリーンアップでタイマー解除（再レンダリング時）
      return () => clearTimeout(timer);
    }
  }, [flash, handleFlash]);

  const handleClose = () => {
    handleFlash(false, '', '');
  };

  return (
    <Presentation
      flash={flash}
      flashType={flashType}
      flashMessage={flashMessage}
      handleClose={handleClose}
    />
  );
};
